/** Le module Node `os`, réduit à ce que server.js utilise. */
export const homedir = () => '/scanyt';
